var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-3"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('Gift',{attrs:{"gifts":_vm.gifts},model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header border-0"},[_c('h5',{staticClass:"card-title"},[_vm._v("هدایا")])])
}]

export { render, staticRenderFns }